/* Manufacturing Insights — thin API map over the portal's HttpClient (which already
 * sets the /api base URL, attaches the Bearer token, and handles 401 -> logout).
 * Mirrors the .NET ManufacturingInsightsController routes (api/manufacturing-insights/*).
 */
import httpClient from "@/assets/js/HttpClient";

const B = "/manufacturing-insights";
const get = (path) => httpClient.get(B + path).then(r => r.data);

export default {
  health: () => get("/health"),
  freshness: () => get("/freshness"),
  provenance: () => get("/provenance"),
  overview: () => get("/overview"),
  forecast: () => get("/forecast"),
  kpis: () => get("/kpis"),

  shipped: () => get("/shipped"),
  shippedDaily: (y, m) => get(`/shipped/daily/${y}/${m}`),
  partsSales: () => get("/parts-sales"),
  partsInvoices: (y, m) => get(`/parts-sales/invoices/${y}/${m}`),
  partsLines: (y, m) => get(`/parts-sales/lines/${y}/${m}`),
  labor: () => get("/labor"),
  hrsPerTon: () => get("/hrs-per-ton"),
  laborWeekly: (dept) => get(`/labor/weekly/${encodeURIComponent(dept)}`),
  scrap: () => get("/scrap"),
  scrapTop: () => get("/scrap/top"),
  shipping: () => get("/shipping"),
  shippingLate: () => get("/shipping/late"),
  shippingIntegrity: () => get("/shipping/integrity"),
  shippingDetail: (y, m) => get(`/shipping/detail/${y}/${m}`),
  shippingLateMonthly: () => get("/shipping/late/monthly"),
  machineshop: () => get("/machineshop"),
  machineshopWeekly: (y, m) => get(`/machineshop/weekly/${y}/${m}`),
  chrome: () => get("/chrome"),
  chromeDetail: (y, m) => get(`/chrome/detail/${y}/${m}`),
  inventory: () => get("/inventory"),
  rma: () => get("/rma"),
  rmaTop: () => get("/rma/top"),
  rmaDetail: (y, m) => get(`/rma/detail/${y}/${m}`),

  // Profitability tab (Machining/Assembly dept P&L; op = MACHINING|ASSEMBLY)
  profitability: (op) => get(`/profitability?op=${encodeURIComponent(op || "MACHINING")}`),
  profitabilityStatement: (op, y, m) => get(`/profitability/statement/${encodeURIComponent(op)}/${y}/${m}`),
  // Working Capital tab (inventory value / turns / dead-stock from live VMFG)
  workingCapital: () => get("/working-capital"),

  /* Part Cost Variance tab — per-part actual cost per piece, month over month, vs the ±10% JCS
   * allowance. `basis` is 'sold' (customer shipments) or 'made' (WO + PO receipts); the backend
   * coerces anything else to 'sold'. Part IDs go as QUERY STRING params, never route segments:
   * VISUAL PART_IDs contain spaces and can contain '/', and IIS rejects an encoded slash in a path
   * by default. `period` is an ISO first-of-month date ('2026-08-01'). */
  partCost: (basis) => get(`/part-cost?basis=${encodeURIComponent(basis || "sold")}`),
  partCostMonthly: (basis) => get(`/part-cost/monthly?basis=${encodeURIComponent(basis || "sold")}`),
  partCostParts: (basis, scope, period) =>
    get(`/part-cost/parts?basis=${encodeURIComponent(basis || "sold")}&scope=${encodeURIComponent(scope || "all")}` +
        (period ? `&period=${encodeURIComponent(period)}` : "")),
  partCostPart: (basis, part) =>
    get(`/part-cost/part?basis=${encodeURIComponent(basis || "sold")}&part=${encodeURIComponent(part)}`),
  partCostTxn: (basis, part, period) =>
    get(`/part-cost/txn?basis=${encodeURIComponent(basis || "sold")}&part=${encodeURIComponent(part)}` +
        `&period=${encodeURIComponent(period)}`),

  // report-access gate (reuses the existing portal endpoint / 'manufacturing-insights' key)
  accessMine: () => httpClient.get("/report/access/mine").then(r => r.data),
};
